import { render, staticRenderFns } from "./CreateAppSetting.vue?vue&type=template&id=df7f04c4&"
import script from "./CreateAppSetting.vue?vue&type=script&lang=js&"
export * from "./CreateAppSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports